<template>
  <div
    class="template-group-index"
    v-loading="pageLoading"
    element-loading-text="正在加载模板数据..."
    element-loading-spinner="el-icon-loading"
  >
    <section class="tgi-body" @mousemove="onMousemove">
      <div class="tgi-body-tools">
        <div class="tbt-left">
          <div class="tbt-home-link">
            <app-title name="编辑" :isHomePage="false"></app-title>
          </div>
          <div style="margin-top: -3px">
            <el-button
              round
              :disabled="!hasCacheData"
              class="roll-back-btn"
              @click="onRollback"
            >
              <i class="iconfont icon-repeal icon-size13"></i
              ><span class="label">撤销</span>
            </el-button>
            <el-button
              round
              :disabled="!hasCacheData"
              class="roll-back-btn"
              @click="onReset"
            >
              <i class="iconfont icon-recover icon-size13"></i
              ><span class="label">恢复</span>
            </el-button>
            <el-button
              round
              v-if="hiddenList.length > 0"
              @click="showHiddenDialog"
            >
              <span class="label">显示/隐藏</span>
            </el-button>
          </div>
        </div>
        <el-dropdown
          placement="bottom"
          trigger="click"
          @visible-change="handleVisibleChange"
        >
          <div class="tbt-center">
            <p class="title-size">
              {{ worksObj.name }} <i class="el-icon-arrow-down" />
            </p>
            <p class="title-name">
              {{ `${widthAndHeight.width}x${widthAndHeight.height}` }}
            </p>
          </div>
          <el-dropdown-menu slot="dropdown">
            <div class="tpl-edit-box">
              <el-form ref="form" :model="worksObj" label-width="60px">
                <el-form-item label="名称：">
                  <el-input v-model="worksObj.name" :maxlength="40"></el-input>
                </el-form-item>
                <el-form-item label="标签：">
                  <div class="m-tags">
                    <template v-if="tagsList.length > 0">
                      <span
                        v-for="item in tagsList"
                        :key="item.id"
                        class="c-tag-item hover"
                        :class="{
                          'm-selected': worksObj.workTagIds.includes(item.id)
                        }"
                        @click="handleTagClick(item.id)"
                        >{{ item.name }}</span
                      >
                    </template>
                    <span v-else style="color: #999;"
                      >项目管理员还未配置任何标签</span
                    >
                  </div>
                </el-form-item>
              </el-form>
            </div>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="op-btns-box">
          <el-button class="op-btn" @click="onPreview" round>预览</el-button>
          <template v-if="$route.query.type === 'team'">
            <el-dropdown @command="onSaveCommand">
              <el-button
                class="op-btn t-save-btn c-btn-color"
                :loading="saveLoading"
                round
                >保存作品</el-button
              >
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="self">
                  保存为个人作品
                </el-dropdown-item>
                <el-dropdown-item command="both">
                  保存并更新团队作品
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
          <el-popover
            v-else
            placement="bottom"
            title=""
            width="200"
            :disabled="$route.query.type !== 'my'"
            trigger="hover"
            content="个人作品保存后, 将同步显示在团队作品库"
          >
            <el-button
              slot="reference"
              class="op-btn t-save-btn c-btn-color"
              @click="onClickSave"
              round
              :loading="saveLoading"
            >
              <span>保存作品</span>
            </el-button>
          </el-popover>
          <el-dropdown class="op-btn" @command="onExport">
            <el-button type="primary" round :loading="exportLoading">
              导出<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <template v-if="currentItem.type === multiple">
                <div class="c-multiple-export">
                  <div>
                    <div>文件类型</div>
                    <el-radio v-model="exportFileType" label="png"
                      >PNG</el-radio
                    >
                    <br />
                    <el-radio v-model="exportFileType" label="jpg"
                      >JPG</el-radio
                    >
                  </div>
                  <div>
                    <div>下载方式</div>
                    <el-radio v-model="exportType" label="slice"
                      >多图下载</el-radio
                    >
                    <br />
                    <el-radio v-model="exportType" label="one"
                      >完整页面下载</el-radio
                    >
                  </div>
                  <el-button type="primary" @click="onMultiModeExport()"
                    >确定导出</el-button
                  >
                </div>
              </template>
              <template v-else>
                <el-dropdown-item
                  command="ppt"
                  v-if="currentItem.type === ppt"
                  style="padding:0"
                >
                  <el-tooltip
                    v-if="isMac()"
                    class="item"
                    content="为避免视觉上出现元素偏差, mac用户推荐使用16.35或更高版本office"
                    placement="left"
                  >
                    <div style="padding: 0 17px">ppt</div>
                  </el-tooltip>
                  <div v-else style="padding: 0 17px">ppt</div>
                </el-dropdown-item>
                <el-dropdown-item command="png">png</el-dropdown-item>
                <el-dropdown-item command="jpg">jpg</el-dropdown-item>
              </template>
            </el-dropdown-menu>
          </el-dropdown>
          <span class="save-msg">{{ saveMessage }}</span>
        </div>
      </div>
      <div class="tgi-body-content">
        <aside class="tgi-aside">
          <el-button
            type="default"
            class="add-tpl c-btn-color"
            round
            @click="onAddEmptyTemplate"
            >添加画布
          </el-button>
          <ul>
            <draggable
              v-model="dataList"
              @end="onDragEnd"
              handle=".drag-item"
              ghostClass="drop-receiver-class"
              dragClass="drag-move-class"
            >
              <li
                v-for="(item, index) in dataList"
                class="drag-item"
                :class="{ 'aside-item-active': activeId === item.onlyId }"
                :key="item.onlyId"
                v-loading="exportLoadingData.indexOf(item.onlyId) > -1"
                element-loading-text="下载中..."
                element-loading-spinner="el-icon-loading"
              >
                <div class="c-tpl-tools">
                  <el-tooltip
                    v-if="templateUpdatedBtnVisible"
                    class="item"
                    effect="dark"
                    content="更新模板"
                    placement="top"
                  >
                    <span @click.stop="onUpdateTemplate(item)"
                      ><i class="el-icon-refresh-right"></i
                    ></span>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="下载"
                    placement="top"
                    v-if="!isEmptyTemplate(item.id)"
                  >
                    <span @click.stop="onItemExport(item)" title="下载"
                      ><i class="el-icon-bottom"></i
                    ></span>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="复制"
                    placement="top"
                  >
                    <span @click.stop="onCopyTemplate(index)" title="复制"
                      ><i class="el-icon-copy-document"></i
                    ></span>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="删除"
                    placement="top"
                  >
                    <span @click.stop="onDelTemplate(index)" title="删除"
                      ><i class="el-icon-delete"></i
                    ></span>
                  </el-tooltip>
                </div>
                <div @click.capture="onAsideItemClick(item)">
                  <tpl-editor-area
                    :disabled="true"
                    v-model="item.json"
                    :edit="false"
                    :scale="item.asideScale"
                  ></tpl-editor-area>
                </div>
                <p class="del-tag c-tip" v-if="delTagVisible(item.id)">
                  模板已删除
                </p>
                <p class="tpl-item-name" :title="item.name">{{ item.name }}</p>
              </li>
            </draggable>
          </ul>
        </aside>
        <div class="body-content" ref="tgiBodyRef">
          <div
            class="tgi-body-scale-layout"
            ondragstart="return false;"
            @mouseup="onSelectionMouseup"
          >
            <tpl-editor-group
              :class="{ 'tpl-moving': dragMoving }"
              :key="resetRenderKey"
              :dataList="dataList"
              :activeId="activeId"
              :scale="scale"
              :dragMoving="dragMoving"
              @mousedown.native="onMousedown"
              @click.native="onTemplateClick"
              @onOpenGroupDialog="onOpenGroupDialog"
              @onOptionListClick="onModuleClick"
              @onMaterialImgClick="onMaterialImgClick"
              @onTextBlur="onTextBlur"
              @onTextFocus="onTextFocus"
              @onItemClick="onItemClick"
              @onCssTextClick="onCssTextClick"
              @addCache="addCache"
              @onKeydown="onKeydown"
              @onCutImg="onCutImg"
              @onTableClick="onTableClick"
              @onTplClick="onTplClick"
            ></tpl-editor-group>
          </div>
        </div>
        <scale-tools
          v-model="scale"
          v-show="!dragMoving"
          :y="130"
          :x="85"
          @onMinus="onMinus"
          @onPlus="onPlus"
          @onReset="onResetScale"
        ></scale-tools>
        <div class="tpl-right-aside">
          <base-panel
            v-show="panelVisibleValue === 'basePanel'"
            @onBgOpacityChange="setBgOpacity"
            @onBgColorChange="setBgColor"
            @addCache="addCache"
            @onHeightChange="onHeightChange"
            :currentItem="currentItem"
            :currentBgList="currentBgList"
            :bgOpacity="opacityValue"
            :bgColor="bgColor"
          ></base-panel>
          <module-panel
            v-show="panelVisibleValue === 'modulePanel'"
            :moduleGroupList="moduleGroupList"
            :currentModule="currentModule"
            :currentTemplate="currentItem"
            :loading="queryModuleGroupLoading"
            @onRemoveModule="onRemoveModule"
            @onReplaceModuleGroup="replaceModuleGroup"
            @setCurrentModule="setCurrentModule"
            @autoSave="autoSave"
            @addCache="addCache"
          ></module-panel>
          <text-panel
            v-show="panelVisibleValue === 'textPanel'"
            v-if="currentItem.id"
            ref="textPanelRef"
            :currentTemplate="currentItem"
            :selectedItem="selectedItem"
            :default-bg="currentItem.json.defaultTextBg"
            :imgUrl="theColorUrl"
            :onSelectionMouseup="onSelectionMouseup"
            :selectionEvent="selectionEvent"
            @addCache="addCache"
            @setSelectionText="setSelectionText"
            @generateImg="generateImg"
          ></text-panel>
          <material-panel
            ref="materialPanelRef"
            class="aside-attr"
            :projectId="projectId"
            :tplGroupId="this.worksObj.tplGroupId"
            :validateLocal="!wordDialogVisible"
            v-if="panelVisibleValue === 'materialPanel'"
            @onMaterialClick="onMaterialClick"
          ></material-panel>
          <table-panel
            v-if="panelVisibleValue === 'tablePanel'"
            :data="tablePanelData"
            :templateIds="templateIds"
            :projectId="projectId"
            @onOpenAdminDialog="onOpenAdminDialog"
            @onReplaceTableTheme="onReplaceTableTheme"
            @onOpenThemeDialog="onOpenThemeDialog"
            @autoSave="autoSave"
            @addCache="addCache"
          ></table-panel>
          <div class="c-popo-box">
            <a
              target="_blank"
              href="http://popo.netease.com/static/html/open_popo.html?ssid=grp.zhitu@corp.netease.com&sstp=0"
              class="popo-tools"
            >
              <img src="/img/popo.png" height="32"/>联系我们</a
            >
          </div>
        </div>
      </div>
      <img-template-dialog
        class="tgi-index-dialog"
        :size="materialGroupSize"
        @completed="onMaterialGroupConfirm"
        @clickImg="onClickGroupImg"
        :data="groupArray"
      ></img-template-dialog>
    </section>
    <el-dialog
      custom-class="tpl-group-dialog"
      title="预览"
      :visible.sync="dialogVisible"
      width="70%"
      @closed="handleClose"
    >
      <div class="tgd-body">
        <div
          class="tgd-loading"
          v-loading="previewLoading"
          element-loading-text="正在生成预览图..."
          element-loading-spinner="el-icon-loading"
        ></div>
        <img
          :src="previewUrl"
          v-show="previewUrl"
          @load="onPreviewLoad"
          alt=""
          style="margin: 0 auto"
        />
      </div>
      <!--<span slot="footer" class="dialog-footer"></span>-->
    </el-dialog>
    <self-cropper
      ref="selfCropperRef"
      :selectedItem="selectedItem"
      @click.stop
      :psd-data="currentItem"
      @completed="onCropperCompleted"
    >
      <template slot="view" slot-scope="slotData">
        <tpl-editor-area
          :edit="false"
          :value="slotData.psdJson"
          :scale="slotData.scale"
        ></tpl-editor-area>
      </template>
    </self-cropper>
    <templates-dialog
      v-model="tplsDialogVisible"
      :data-list="originDataList"
      @onAdd="addTemplate"
    ></templates-dialog>
    <word-user-dialog
      v-model="wordUserDialogVisible"
      :data="userWordData"
      :isPPT="currentItem.type === ppt"
      :projectId="projectId"
      :currentTemplateId="currentItem.id"
      :templateIds="templateIds"
      @onConfirm="onWordDialogConfirm"
    ></word-user-dialog>
    <word-admin-dialog
      ref="wordDialogRef"
      v-model="wordAdminDialogVisible"
      :data="wordData"
      :themeData="themeData"
      :projectId="projectId"
      :currentTemplateId="currentItem.id"
      :templateIds="templateIds"
      :centerBox="true"
      @onOpenMaterial="onOpenMaterial"
      @onCloseThemeDialog="onCloseThemeDialog"
      @onConfirm="onWordDialogConfirm"
    ></word-admin-dialog>
    <hidden-dialog
      v-model="hiddenDialogVisible"
      ref="hiddenDialogRef"
      :data="hiddenList"
      :template="currentItem"
      @onAddCache="addCache"
    ></hidden-dialog>
    <transition name="s-fade">
      <div class="ppt-download-loading" v-if="pptLoading">
        <div>
          <div>请耐心等待...</div>
          <el-progress type="circle" :percentage="percentage"></el-progress>
          <div>
            <el-button type="primary" @click="pptLoading = false"
              >关闭</el-button
            >
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import templateService from '@/request/service/template-service'
import workService from '@/request/service/works-service'
import uploadService from '@/request/service/fileupload-service'
import groupService from '@/request/service/group-service'
import tplEditorArea from './editor/tpl-editor-area'
import tplEditorGroup from './editor/tpl-editor-area-group'
import materialPanel from './attr-panel/material-panel'
import selfCropper from './template-group-cropper'
import imgTemplateDialog from '../template/img-template/img-template-dialog'
import templatesDialog from './tpls-dialog/tpl-selections-dialog'
import wordUserDialog from './tpls-dialog/tpl-word-user-dialog'
import wordAdminDialog from './tpls-dialog/tpl-word-admin-dialog'
import hiddenDialog from './tpls-dialog/tpl-hidden-dialog'
import appTitle from '@/views/layout/app-title'
import scaleTools from '../components/scale-tools'
import tablePanel from './attr-panel/table-panel'
import util from '@/util.js'
import ImgCoverUtil from '../components/attr-dialog/ImgCoverUtil'
import {
  error_code_400003,
  group_type_mk,
  group_type_pt,
  empty_template_group,
  template_type_multiple,
  template_type_ppt,
  text_bg_set,
  screenshot_works_url,
  screenshot_work_url,
  empty_tpl_group_works,
  minus_plus
} from '@/const.js'
import basePanel from './attr-panel/base-panel'
import modulePanel from './attr-panel/module-panel'
import textPanel from './attr-panel/text-panel'
import Selection from './Selection'
import TUtil from './TUtil'
import IndexedDB from '../../WebDB.js'
import routerMixin from '@/mixins/router-mixin.js'
import { Loading } from 'element-ui'
import draggable from 'vuedraggable'
const WebDb = new IndexedDB('templateGroup')
const aside_width = 168
const module_panel_width = 320
const empty_template_bg_color = '#fff'
const session_storage_key = 'tpl_group_data'
export default {
  components: {
    // editorHeader,
    tplEditorArea,
    tplEditorGroup,
    draggable,
    materialPanel,
    selfCropper,
    imgTemplateDialog,
    basePanel,
    modulePanel,
    textPanel,
    templatesDialog,
    wordUserDialog,
    wordAdminDialog,
    hiddenDialog,
    appTitle,
    scaleTools,
    tablePanel
  },
  mixins: [routerMixin],
  data () {
    return {
      ppt: template_type_ppt,
      multiple: template_type_multiple,
      projectId: null,
      dataList: [],
      cacheArray: [],
      hasCacheData: false,
      originDataList: [],
      scale: 1,
      activeId: null,
      exportLoading: false,
      dialogVisible: false,
      previewLoading: false,
      saveLoading: false,
      cropperVisible: false,
      previewUrl: '',
      materialGroupSize: { width: null, height: null },
      currentModule: {
        data: {},
        scale: 1
      },
      selectedModuleGroupItemIndex: null,
      pageLoading: true,
      materialGroupList: [],
      selectionTextNotChange: null,
      moduleGroupList: [],
      moduleGroupListCache: {},
      opacityValue: 100,
      bgColor: empty_template_bg_color,
      textSize: null,
      tagsList: [],
      worksObj: JSON.parse(JSON.stringify(empty_tpl_group_works)),
      saveMessage: '',
      panelVisibleValue: 'basePanel',
      resetRenderKey: 0,
      dragMoving: false, //鼠标是否移动中
      exportCheckList: [],
      checkAll: false,
      exportLoadingData: [],
      tplsDialogVisible: false,
      queryModuleGroupLoading: false,
      wordDialogVisible: false,
      wordUserDialogVisible: false,
      wordAdminDialogVisible: false,
      tablePanelData: {
        width: 0,
        height: 0
      },
      userWordData: {
        width: 0,
        height: 0
      },
      wordData: {
        width: 0,
        height: 0
      },
      themeData: {},
      hiddenList: [],
      hiddenDialogVisible: false,
      templateIds: [],
      theColorUrl: '',
      selectionEvent: null,
      tableLoading: false,
      exportFileType: window.localStorage.getItem('exportFileType') || '',
      exportType: window.localStorage.getItem('exportType') || '',
      percentage: 0,
      pptLoading: false,
      tplModuleList: []
    }
  },
  computed: {
    currentItem () {
      if (this.dataList && this.dataList.length > 0 && this.activeId) {
        let arr = this.dataList.filter(item => {
          return item.onlyId === this.activeId
        })
        return arr.length > 0 ? arr[0] : { json: {} }
      } else {
        return {
          json: {}
        }
      }
    },
    currentBgList () {
      let bgList = []
      if (this.currentItem.json && this.currentItem.json.children) {
        util.getBgByDeep(this.currentItem.json, bgList)
      }
      return bgList
    },
    groupArray () {
      return this.$store.state.group.groupArray
    },
    selectedItem () {
      return this.$store.state.templateGroup.selectedItem
    },
    widthAndHeight () {
      if (this.dataList && this.dataList.length > 0) {
        let width = this.dataList[0].json.width
        let height = null
        this.dataList.forEach(item => {
          height += +item.json.height
        })
        return { width, height }
      } else {
        return { width: '', height: '' }
      }
    },
    templateUpdatedBtnVisible () {
      return (
        this.$store.getters['app/isAdmin'] &&
        this.$route.name === 'template-group-editor'
      )
    }
  },
  beforeDestroy () {
    this.removeEvent()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      let fromPath = sessionStorage.getItem('from')
      if (!fromPath) {
        sessionStorage.setItem('from', from.fullPath)
      }
    })
  },
  beforeRouteLeave (to, from, next) {
    WebDb.remove(this.$route.params.id)
    let pageKey = `${from.meta.userActionKey}`
    let endTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
    this.saveUserAction(
      pageKey,
      this.ActionType.page.leave.key,
      this.worksObj.type,
      null,
      this.worksObj.tplGroupId,
      this.userActionStartTime,
      endTime
    )
    sessionStorage.removeItem('from')
    next()
  },
  created () {
    this.userActionStartTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss') // 记录pv开始时间

    let self = this
    let routerFullPath = this.$route.fullPath
    window.onbeforeunload = () => {
      this.hasCacheData = false
      // 刷新页面时 保留刷新前数据
      sessionStorage.setItem(
        session_storage_key,
        JSON.stringify({
          templateId: self.currentItem.id,
          dataList: self.dataList,
          routerFullPath: routerFullPath
        })
      )
    }
  },
  mounted () {
    window.addEventListener('mouseup', this.onMouseup)
    this.init()
  },
  methods: {
    init () {
      let id = this.$route.params.id
      if (!id) {
        this.$message.error('url参数错误')
        return
      }
      let routerName = this.$route.name
      if (routerName === 'template-group-editor') {
        this.getTemplateData(id)
      } else {
        this.getWorkData(id)
      }
    },
    handleVisibleChange (val) {
      if (!val) {
        if (this.worksObj.name && this.worksObj.name.trim()) {
          if (this.$route.name === 'template-group-editor') return
          workService
            .rename({
              id: this.worksObj.id,
              name: this.worksObj.name
            })
            .then(() => {
              this.originName = this.worksObj.name
            })
            .catch(e => this.$message.error('修改失败'))
        } else {
          this.worksObj.name = this.originName
        }
        if (this.$route.name === 'template-group-editor') return
        const tagNames = this.tagsList
          .filter(item => this.worksObj.workTagIds.includes(item.id))
          .map(item => item.name)
        workService
          .setWorkTags(this.worksObj.projectId, {
            workId: this.worksObj.id,
            tagNames
          })
          .then()
          .catch(e => this.$message.error('修改失败'))
      }
    },
    getTags () {
      this.originName = this.worksObj.name
      workService.getWorkTagList(this.projectId).then(d => {
        this.tagsList = d
      })
    },
    handleTagClick (id) {
      if (this.worksObj.workTagIds.includes(id)) {
        this.worksObj.workTagIds.splice(this.worksObj.workTagIds.indexOf(id), 1)
      } else {
        this.worksObj.workTagIds.push(id)
      }
      this.$forceUpdate()
    },
    scaleToolsStyle () {
      let screenW = document.body.offsetWidth
      let twoAsideW = 560,
        halfToolsWidth = 70,
        leftAside = 230
      let editorW = screenW - twoAsideW // 减去两边aside
      let left = leftAside + editorW / 2 - halfToolsWidth // 居中位置
      return `left: ${left}px`
    },
    getSessionStorageData () {
      // 从session中获取缓存数据
      let routerFullPath = this.$route.fullPath
      let sessionStorageData = sessionStorage.getItem(session_storage_key)
      if (sessionStorageData) {
        // 从当前缓存中获取操作的数据
        let cacheData = JSON.parse(sessionStorageData)
        if (cacheData.routerFullPath !== routerFullPath) {
          return null
        }
        if (cacheData.dataList && cacheData.dataList.length > 0) {
          return cacheData
        } else {
          return null
        }
      }
      return null
    },
    isMac () {
      return util.isMac()
    },
    async getTemplateData (templateId) {
      templateService
        .getTemplateGroupByTemplateId(templateId)
        .then(dataList => {
          let item = dataList[0]
          let tplGroupName = item.tplGroupName
          this.projectId = item.projectId
          Object.assign(this.worksObj, item)
          this.worksObj.name = tplGroupName
          this.worksObj.id = null
          this.getTags()
          this.setDataList(dataList, templateId, item.projectId)
          this.getWordTableList(dataList)
          this.$store.dispatch('app/queryFontList', {
            projectId: item.projectId
          })
          this.saveUserAction(
            this.$route.meta.userActionKey,
            this.ActionType.page.enter.key,
            this.worksObj.type,
            null,
            this.worksObj.tplGroupName,
            this.userActionStartTime
          )
        })
        .catch(data => {
          if (data.code === error_code_400003) {
            this.$message.error(data.message)
            setTimeout(() => {
              this.$router.push('/')
            }, 2000)
          }
        })
        .finally(() => {
          this.pageLoading = false
        })
    },
    setDataList (originDataList, templateId, projectId) {
      let cacheData = this.getSessionStorageData()
      let dataList = cacheData ? cacheData.dataList : originDataList
      dataList = this.setDataListOnlyId(dataList)
      this.originDataList = JSON.parse(
        JSON.stringify(this.setDataListOnlyId(originDataList))
      )
      this.setAsideScale(dataList)
      this.dataList = dataList
      let arr = this.dataList.filter(item => {
        return item.id === templateId
      })
      let item = null
      if (arr && arr.length > 0) {
        item = arr[0]
      } else {
        item = this.dataList[0]
      }
      this.$nextTick(() => {
        this.setScrollPosition()
      })
      this.setActiveTemplate(item)
      this.setDefaultScale(dataList)
      this.getMaterialGroupData(dataList, templateId, projectId)
    },
    async getWorkData (workId) {
      workService
        .getWorksById(workId)
        .then(data => {
          Object.assign(this.worksObj, data)
          this.projectId = data.projectId
          this.getTags()
          let dataList = data.json.dataList
          let templateId = dataList[0].id
          this.setDataList(dataList, templateId, data.projectId)
          this.getWordTableList(dataList)
          this.$store.dispatch('app/queryFontList', {
            projectId: data.projectId
          })
          this.saveUserAction(
            this.$route.meta.userActionKey,
            this.ActionType.page.enter.key,
            this.worksObj.type,
            null,
            this.worksObj.tplGroupName,
            this.userActionStartTime
          )
        })
        .finally(() => {
          this.pageLoading = false
        })
    },
    setDataListOnlyId (dataList) {
      // 设置唯一的id值，避免复制时id做比较出现重复
      dataList.forEach(item => {
        item.onlyId = util.getUUID()
      })
      return dataList
    },
    getIds (dataList) {
      return dataList
        .filter(item => {
          return !this.isEmptyTemplate(item.id)
        })
        .map(item => {
          return item.id
        })
    },
    getMaterialGroupData (dataList, templateId, projectId) {
      let ids = this.getIds(dataList)
      let params = {
        type: group_type_pt,
        templateIds: ids,
        projectId: projectId
      }
      groupService.getGroupList(params).then(({ list }) => {
        this.materialGroupList = list
        this.setMaterialGroupByTemplateId(templateId)
      })
    },
    setMaterialGroupByTemplateId (templateId) {
      let list = this.materialGroupList.filter(item => {
        return item.templateId === templateId
      })
      if (list && list.length > 0) {
        this.$store.commit('group/set_groups', list)
      } else {
        this.$store.commit('group/set_groups', [])
      }
    },
    setDefaultScale (dataList) {
      let leftW = 200,
        rightW = 370,
        margin = 100,
        width = dataList[0].json.width
      let midW = document.body.offsetWidth - leftW - rightW - margin
      this.scale = util.getScaleWidth(midW, width)
    },
    setAsideScale (dataList) {
      dataList.forEach(item => {
        item.asideScale = parseFloat(
          (aside_width / +item.json.width).toFixed(2)
        )
      })
    },
    onCopyTemplate (index) {
      this.addCache()
      let item = this.dataList[index]
      let newItem = JSON.parse(JSON.stringify(item))
      newItem.onlyId = util.getUUID()
      newItem.name = newItem.name + ' ' + moment().format('YYYYMMDDhhmm')
      this.dataList.splice(index + 1, 0, newItem)
      this.saveUserAction(
        this.getActionPage().name.key,
        this.getActionPage().copy.key
      )
    },
    onDelTemplate (index) {
      if (this.dataList.length === 1) {
        this.$message.error('至少需要一个模板')
        return
      }
      this.addCache()
      let activeIndex = index === 0 ? 1 : index - 1
      this.setActiveTemplate(this.dataList[activeIndex])
      this.dataList.splice(index, 1)
      this.saveUserAction(
        this.getActionPage().name.key,
        this.getActionPage().del.key
      )
    },
    onAddEmptyTemplate () {
      this.tplsDialogVisible = true
    },
    createEmptyTemplate () {
      let item = JSON.parse(JSON.stringify(empty_template_group))
      let name = '空白_' + new Date().getTime()
      item.id = `empty_${new Date().getTime()}`
      item.onlyId = util.getUUID()
      item.defaultUrl = '/img/empty_template.png'
      item.name = name
      let firstTpl = this.dataList[0] || {}
      item.tplGroupId = firstTpl.tplGroupId
      item.tplGroupName = firstTpl.tplGroupName
      item.json.name = name
      item.json.width = firstTpl.json.width
      let isPPT = firstTpl.type === template_type_ppt
      item.json.height = isPPT ? firstTpl.json.height : 500
      item.json.id = '1'
      item.json.backgroundColor = empty_template_bg_color
      return item
    },
    addTemplate (templateData) {
      // console.log(1, JSON.stringify(this.dataList), templateData)
      templateData = templateData ? templateData : this.createEmptyTemplate()
      let item = JSON.parse(JSON.stringify(templateData))
      item.onlyId = util.getUUID()
      let index = this.dataList.findIndex(item => {
        return this.activeId === item.onlyId
      })
      if (index > -1) {
        this.dataList.splice(index + 1, 0, item)
      } else {
        this.dataList.push(item)
      }
      this.setAsideScale(this.dataList)
      // console.log(2, JSON.stringify(this.dataList))
    },
    onAsideItemClick (item) {
      this.selectAideItem(item)
      this.saveUserAction(
        this.getActionPage().name.key,
        this.getActionPage().selection.key
      )
    },
    selectAideItem (item) {
      this.panelVisibleValue = 'basePanel'
      if (this.activeId !== item.onlyId) {
        this.setActiveTemplate(item)
        this.setScrollPosition()
      }
    },
    onTplClick (item) {
      if (this.activeId !== item.onlyId) {
        this.setActiveTemplate(item)
      }
    },
    getTemplateId (activeId) {
      let idx = this.dataList.findIndex(item => {
        return item.onlyId === activeId
      })
      return this.dataList[idx].id
    },
    isEmptyTemplate (id) {
      return id.indexOf('empty_') > -1
    },
    setActiveTemplate (item) {
      // this.panelVisibleValue = 'basePanel';
      // this.currentModule.data = {};
      this.activeId = item.onlyId
      let templateId = item.id
      if (!this.isEmptyTemplate(item.id)) {
        this.setMaterialGroupByTemplateId(templateId)
        let moduleGroupList = this.moduleGroupListCache[templateId]
        if (moduleGroupList) {
          //查询可替换的模块组方案
          this.moduleGroupList = moduleGroupList
        } else {
          this.getModuleGroupData(item.projectId, templateId)
        }
      }
      this.bgColor = item.json.backgroundColor
      this.$nextTick(() => {
        this.setDataByDeep(item)
      })
    },
    setBlankSpaceForTplModule () {
      let mList = this.tplModuleList
      if (mList.length < 2) {
        return
      }
      mList.sort((a, b) => {
        return a.top - b.top
      })
      let m1 = mList[0],
        m2 = mList[1]
      let minusVal = m2.top - m1.bottom
      if (minusVal < 0) {
        return
      }
      mList.forEach(item => {
        // 默认获取前两个模板组的间距，后面添加或删除模板组时，需要使用此间距
        item.blankSpace = minusVal
      })
    },
    setDataByDeep (editorObj) {
      this.tplModuleList = []
      this.hiddenList = []
      this.$refs.hiddenDialogRef._reset()
      this.deepChildren(editorObj.json.children)
      this.setBlankSpaceForTplModule()
    },
    deepChildren (children) {
      children &&
        children.forEach(item => {
          if (!item.key) {
            item.key = util.getUUID()
          }
          if (item.isModuleGroup) {
            this.fixedModule(item)
            this.tplModuleList.push(item)
          }
          if (item.children) {
            this.deepChildren(item.children)
          }
          if (item.allowHide && !item.disabled) {
            this.hiddenList.push(item)
          }
        })
    },
    fixedModule (item) {
      // 模块组中的fixed属性重置成false,此属性用来固定元素不做移动,原来设置的值要取消
      if (item.children) {
        item.children.forEach(obj => {
          this.fixedModule(obj)
        })
      } else if (item.fixed) {
        item.fixed = false
      }
    },
    getModuleGroupData (projectId, templateId) {
      this.queryModuleGroupLoading = true
      let paramsMK = {
        projectId: projectId,
        templateIds: [templateId],
        type: group_type_mk
      }
      groupService
        .getGroupList(paramsMK)
        .then(({ list }) => {
          if (list && list.length > 0) {
            list.forEach(item => {
              let width = item.json.width
              let height = item.json.height
              item.scale = util.getScaleWidthAndHeight(140, 140, width, height)
            })
          }
          this.moduleGroupList = list
          this.moduleGroupListCache[templateId] = list
        })
        .finally(() => {
          this.queryModuleGroupLoading = false
        })
    },
    setScrollPosition () {
      let activeId = this.activeId
      let scrollTop = 0
      this.dataList.findIndex(obj => {
        if (obj.onlyId !== activeId) {
          scrollTop += +obj.json.height
        }
        return obj.onlyId === activeId
      })
      let scrollDom = this.$refs.tgiBodyRef
      scrollDom.scrollTop = scrollTop * this.scale
    },
    onDragEnd () {
      this.setScrollPosition()
      this.saveUserAction(
        this.getActionPage().name.key,
        this.getActionPage().drag.key
      )
    },
    removeEvent () {
      window.removeEventListener('mouseup', this.onMouseup)
      window.onbeforeunload = null
      sessionStorage.removeItem(session_storage_key)
      window.clearTimeout(this.timeoutVal)
      this.$store.commit('templateGroup/set_before_focus_item', {
        dom: null,
        item: null
      })
    },
    onMouseup () {
      if (this.dragMoving) {
        this.autoSave()
        this.extendBg()
      }
      this.dragMoving = false
    },
    extendBg () {
      let tplJson = this.currentItem.json
      let extensionImgUrl = tplJson.extensionImg
        ? tplJson.extensionImg.url
        : null
      let bgItem = this.currentBgList.length > 0 ? this.currentBgList[0] : null
      if (!bgItem) {
        return
      }
      let currentHeight = +tplJson.height
      let extensionsHeight = currentHeight - +this.originHeight
      let lessBg = bgItem.height < currentHeight
      if (!(bgItem.url && extensionImgUrl && extensionsHeight > 0 && lessBg)) {
        return
      }
      if (this.bgTimeoutVal) {
        window.clearTimeout(this.bgTimeoutVal)
      }
      this.bgTimeoutVal = setTimeout(() => {
        this.bgTimeoutVal = null
        util
          .mergeImgFromUrl(bgItem.url, extensionImgUrl, extensionsHeight)
          .then(base64 => {
            uploadService
              .uploadFileByBase64(base64)
              .then(({ url, properties }) => {
                this.addCache()
                bgItem.height = properties.split('x')[1]
                bgItem.url = url
              })
          })
      })
    },
    onMoveClick ($event) {
      if (
        this.dragMoving &&
        $event.target.className.indexOf('drag-move-bar') === -1
      ) {
        this.dragMoving = false
      }
    },
    onMousedown ($event) {
      if ($event.target.className.indexOf('drag-move-bar') > -1) {
        this.addCache()
        this.dragMoving = true
        this.startY = $event.clientY
        this.originHeight = this.currentItem.json.height
      }
    },
    onMousemove ($event) {
      if (this.dragMoving) {
        let clientY = $event.clientY
        requestAnimationFrame(() => {
          let value = this.startY - clientY
          let item = this.currentItem
          let tplHeight = item.json.height
          if (tplHeight < 1 && value > 0) {
            item.json.height = 0
            return
          }
          value = value === 0 ? 1 : value
          tplHeight = item.json.height - parseInt(value / this.scale)
          item.json.height = tplHeight > 0 ? tplHeight : 0
          this.startY = clientY
        })
      }
    },
    hasDb () {
      return !!(
        window.indexedDB ||
        window.webkitIndexedDB ||
        window.mozIndexedDB
      )
    },
    async addCache () {
      let routerId = this.$route.params.id
      let newStr = JSON.stringify({
        dataList: this.dataList,
        activeId: this.activeId
      })
      let hasDb = this.hasDb()
      let ca = null
      if (this.hasDb) {
        ca = (await WebDb.get(routerId)) || []
      } else {
        ca = this.cacheArray
      }
      //与上次相同的数据，不添加入缓存
      if (ca && ca.length > 0 && JSON.stringify(ca[ca.length - 1]) === newStr) {
        return
      }
      let cloneData = JSON.parse(newStr)
      let cacheLen = 15 // 超过15次缓存记录，清除第一次再记录
      if (ca.length === cacheLen) {
        ca.splice(0, 1)
      }
      ca.push(cloneData)
      if (hasDb) {
        WebDb.set(routerId, ca)
      }
      this.hasCacheData = true
    },
    async onRollback () {
      let hasDb = this.hasDb()
      let routerId = this.$route.params.id
      let cacheArray = []
      if (hasDb) {
        cacheArray = await WebDb.get(routerId)
      } else {
        cacheArray = this.cacheArray
      }
      let lastIndex = cacheArray.length - 1
      let { dataList, activeId } = cacheArray[lastIndex]
      this.dataList = dataList
      if (this.activeId !== activeId) {
        let idx = this.dataList.findIndex(item => {
          return item.onlyId === activeId
        })
        if (idx > -1) {
          this.selectAideItem(this.dataList[idx])
        }
      } else {
        this.setActiveForRollback(activeId)
      }
      cacheArray.splice(lastIndex, 1) // 删除最后一个元素
      if (hasDb) {
        WebDb.set(routerId, cacheArray)
        this.hasCacheData = cacheArray.length > 0
      }
      this.panelVisibleValue = 'basePanel'
      this.saveUserAction(
        this.getActionPage().name.key,
        this.getActionPage().rollback.key
      )
    },
    onReset () {
      if (this.originDataList.length > 0) {
        let hasDb = this.hasDb()
        let routerId = this.$route.params.id
        if (hasDb) {
          WebDb.remove(routerId)
        } else {
          this.cacheArray = []
        }
        this.hasCacheData = false
        this.dataList = JSON.parse(JSON.stringify(this.originDataList))
        this.setAsideScale(this.dataList)
        this.setActiveTemplate(this.dataList[0])
      }
      this.panelVisibleValue = 'basePanel'
      this.resetRenderKey += 1
      this.saveUserAction(
        this.getActionPage().name.key,
        this.getActionPage().reset.key
      )
    },
    setActiveForRollback (activeId) {
      let activeItem = this.dataList.filter(item => {
        return item.onlyId === activeId
      })[0]
      this.setActiveTemplate(activeItem)
    },
    onMinus () {
      this.saveUserAction(
        this.getActionPage().name.key,
        this.getActionPage().minus.key
      )
    },
    onResetScale () {
      if (this.scale === 1) {
        // 默认进入页面时比例和100%比例切换
        this.setDefaultScale(this.dataList)
      } else {
        this.scale = 1
      }
    },
    onPlus () {
      this.saveUserAction(
        this.getActionPage().name.key,
        this.getActionPage().plus.key
      )
    },
    async onPreview () {
      this.dialogVisible = true
      this.previewLoading = true
      let { url } = await this.syncWork()
      this.previewUrl = url
      this.saveUserAction(
        this.getActionPage().name.key,
        this.getActionPage().preview.key
      )
    },
    onPreviewLoad () {
      this.previewLoading = false
    },
    handleClose () {
      this.previewUrl = ''
    },
    onMaterialClick (materialItem) {
      let materialGroupDialogShow = this.$store.state.group.dialogVisiable
      if (materialGroupDialogShow) {
        // 方案组 内素材替换
        let dataList = this.$store.state.group.groupItem.json.data
        if (dataList.length > 0) {
          this.$store.commit('group/set_new_img', materialItem.url)
        }
      } else if (this.selectedItem) {
        // 替换素材内容
        this.addCache()
        let multiImgs = this.$store.state.templateGroup.multiImgItems
        if (multiImgs.length > 0) {
          multiImgs.forEach(imgItem => {
            imgItem.url = materialItem.url
            if (imgItem.coverObj) {
              this.setImgCover(imgItem)
            }
          })
        } else {
          let item = this.selectedItem
          if (item.coverObj) {
            this.setImgCover(item)
          }
          this.$store.commit(
            'templateGroup/set_selected_item_attr',
            materialItem
          )
        }
        this.autoSave()
      }
      this.$refs.selfCropperRef._clearOriginUrl()
      if (this.wordAdminDialogVisible) {
        this.$refs.wordDialogRef._insertImg(materialItem.url)
      }
    },
    setImgCover (item) {
      let coverObj = item.coverObj
      let isImgUrl = !coverObj.color && coverObj.url
      if (isImgUrl) {
        coverObj.url = null
        this.$nextTick(() => {
          ImgCoverUtil.setImgCover(coverObj.colorBackup, item)
        })
      }
    },
    onCropperCompleted (base64) {
      uploadService.uploadFileByBase64(base64).then(({ url }) => {
        this.addCache()
        this.$nextTick(() => {
          this.$store.commit('templateGroup/set_selected_item_attr', {
            url: url
          })
          this.autoSave()
        })
      })
    },
    onPositionChange ({ left, top }) {
      let dom = this.$refs.tgiBodyRef
      let width = dom.scrollWidth + 10
      let height = dom.scrollHeight + 10
      dom.scrollLeft = left * width
      dom.scrollTop = top * height
      this.noTriggerScroll = true
    },
    onOpenGroupDialog (item) {
      this.panelVisibleValue = 'materialPanel'
      this.materialGroupSize = {
        width: item.width,
        height: item.height
      }
      if (item.materialGroup && this.groupArray) {
        let idx = this.groupArray.findIndex(obj => {
          return obj.id === item.materialGroup.id
        })
        if (idx > -1) {
          let newData = [].concat(this.groupArray)
          newData[idx].json.data = item.materialGroup.json.data
          this.$store.commit('group/set_groups', newData)
          this.$store.commit('group/set_group_index', idx)
        } else {
          this.$store.commit('group/set_group_index', 0)
        }
      } else {
        this.$store.commit('group/set_group_index', 0)
      }
      // if(index){
      //     this.onHideItem(index, false);
      // }
      this.$store.commit('group/toggle_dialog', true)
    },
    onMaterialGroupConfirm (materialGroup, url) {
      this.addCache()
      let item = this.selectedItem
      if (item.materialGroup) {
        item.materialGroup = materialGroup
        item.key = util.getUUID()
      } else {
        this.$set(item, 'materialGroup', materialGroup)
        this.$set(item, 'key', util.getUUID())
      }
      item.url = url
      this.autoSave()
    },
    onClickGroupImg () {},
    setCurrentModule (item) {
      this.currentModule.data = item
      this.$store.commit('templateGroup/set_selected_item', item)
      this.$store.commit('templateGroup/set_module_group_selected', {
        item: null,
        parent: null
      })
    },
    onModuleClick (item) {
      //点击模块组事件
      this.currentModule.data = item
      let scale = util.getScale(
        module_panel_width,
        150,
        item.width,
        item.height
      )
      this.currentModule.scale = scale
      this.$store.commit('templateGroup/set_module_group_selected', {
        item: null,
        parent: null
      })
      this.panelVisibleValue = 'modulePanel'

      this.saveUserAction(
        this.getActionPage().name.key,
        this.getActionPage().updateModule.key
      )
    },
    onMaterialImgClick (item, ev) {
      // 点击素材图片时触事件
      if (item.isEditableTable) {
        return
      }
      /** 图片多选处理 start **/
      let dataList = this.$store.state.templateGroup.multiImgItems
      if (ev.ctrlKey || ev.metaKey) {
        this.$store.commit('templateGroup/add_multi_img', item)
      } else if (dataList.length > 0) {
        this.$store.commit('templateGroup/clear_multi_img')
      }
      if (dataList.length > 1) {
        return
      }
      /** 图片多选处理 end **/
      window.setTimeout(() => {
        let name = item.originName || item.name
        let searchName = name.match(/\((.+)\)/g) || '' // 提取()内容
        searchName = searchName ? RegExp.$1 : ''
        this.$refs.materialPanelRef._search(searchName)
      })
    },
    onCssTextClick (cssObj) {
      this.clearTextBgColorSetForSelectionNode()
      this.$refs.textPanelRef._initTextPanel(cssObj)
    },
    onTextFocus (item) {
      if (item.textStyleList) {
        item.textStyleList.forEach(obj => {
          if (obj.isSelectionNode) {
            obj.isSelectionNode = false
          }
        })
      }
      //清空图片多选
      let dataList = this.$store.state.templateGroup.multiImgItems
      if (dataList.length > 0) {
        this.$store.commit('templateGroup/clear_multi_img')
      }
    },
    onTextBlur (ev, item) {
      this.clearSelectionText()
      if (ev.target.textContent !== item.name) {
        this.addCache()
        this.autoSave()
      }
    },
    clearSelectionText () {
      let selectedItem = this.selectedItem
      if (selectedItem && selectedItem.textStyleList) {
        selectedItem.textStyleList.forEach(item => {
          if (item.isSelectionNode) {
            item.isSelectionNode = false
          }
        })
      }
    },
    clearTextBgColorSetForSelectionNode () {
      // 清除当前选中的文字的class，避免dom获取clss对象 依旧是旧值
      let selectedItem = this.selectedItem
      if (selectedItem.textStyleList) {
        selectedItem.textStyleList.forEach(item => {
          if (item.isSelectionNode) {
            item.isSelectionNode = false
          }
        })
      }
    },
    onSelectionMouseup () {
      let section = window.getSelection()
      let selectedItem = this.selectedItem
      if (!section.focusNode || !selectedItem || section.type !== 'Range') {
        this.selectionEvent = null
        return
      }
      let isSelectionText = section.focusNode.parentNode.className.indexOf(
        'selection-text'
      )
      if (isSelectionText > -1) {
        this.selectionEvent = new Selection(section)
      }
      return this.selectionEvent
    },
    setSelectionText () {
      // dom更新后，选中的焦点会消失，需重新选择文本
      let dom = document.querySelector('.item-active .js-selection-text')
      this.$store.commit(
        'templateGroup/set_selected_dom',
        document.querySelector('.item-active').firstElementChild
      )
      if (dom) {
        let selection = window.getSelection()
        let range = document.createRange()
        range.selectNodeContents(dom.firstChild)
        selection.removeAllRanges()
        selection.addRange(range)
        this.selectionEvent = new Selection(selection)
      }
    },
    setBgColor (bgColor) {
      this.addCache()
      let item = this.currentItem.json
      this.bgColor = bgColor
      item.backgroundColor = bgColor
      // console.log(111, item)
    },
    setBgOpacity (value) {
      this.addCache()
      let item = this.currentItem.json
      let opacity = value / 100
      item.children.forEach(item => {
        if (item.isPageBgImg) {
          item.opacity = opacity
        }
      })
      let bgColor = item.backgroundColor
      if (bgColor && bgColor.indexOf('rgb') > -1) {
        let colorArr = this.getColorNum(bgColor)
        colorArr.push(opacity)
        item.backgroundColor = `rgba(${colorArr.join(',')})`
      }
      // console.log(222, item)
    },
    getColorNum (rgb) {
      let arr = rgb
        .split('(')[1]
        .split(')')[0]
        .split(',')
      return [arr[0], arr[1], arr[2]]
    },
    replaceModuleGroup (item) {
      this.addCache()
      let cloneModule = JSON.parse(JSON.stringify(item.json.children))
      cloneModule.forEach(item => {
        if (item.isPageBgImg) {
          item.isPageBgImg = false
        }
      })
      let moduleData = this.currentModule.data
      this.addTopForNewModule(
        cloneModule,
        +moduleData.top,
        +moduleData.left,
        moduleData.id
      )
      moduleData.children = cloneModule
      moduleData.moduleId = item.id
      this.saveUserAction(
        this.getActionPage().name.key,
        this.getActionPage().replaceModule.key
      )
    },
    addTopForNewModule (children, top, left, parentId) {
      children.forEach((item, index) => {
        item.id = `${parentId}_${index + 1}`
        item.top = +item.top + +top
        item.bottom = +item.bottom + +top
        item.left = +item.left + +left
        item.right = +item.right + +left
        if (item.children) {
          this.addTopForNewModule(item.children, top, left, item.id)
        }
      })
    },
    async onSaveCommand (name) {
      if (name === 'both') {
        this.saveTeamWork()
      } else {
        this.saveToSelfWork()
      }
    },
    async onClickSave () {
      this.saveLoading = true
      this.saveWorks().finally(() => {
        this.saveLoading = false
      })
    },
    autoSave () {
      if (this.timeoutVal) {
        this.timeoutVal = null
        window.clearTimeout(this.timeoutVal)
      }
      this.timeoutVal = setTimeout(() => {
        console.info('*************** auto save *****************')
        this.saveWorks()
        this.timeoutVal = null
      }, 60 * 1000)
    },
    syncWork (syncUpdateCover = true) {
      let cloneData = JSON.parse(JSON.stringify(this.worksObj))
      return this.save(cloneData, 'TEMP', syncUpdateCover)
    },
    saveWorks () {
      this.saveAction()
      let cloneData = JSON.parse(JSON.stringify(this.worksObj))
      return this.save(cloneData).then(data => {
        this.saveSuccessMsg()
        this.worksObj.id = data.id
        this.originName = cloneData.name
      })
    },
    saveTeamWork () {
      this.saveLoading = true
      // 保存团队作品
      this.saveWorks().finally(() => {
        this.saveLoading = false
      })
      //同步生成一份到个人作品
      this.saveToSelfWork()
    },
    saveToSelfWork () {
      this.saveWorks()
      let cloneData = JSON.parse(JSON.stringify(this.worksObj))
      cloneData.id = null
      this.saveLoading = true
      this.save(cloneData).finally(() => {
        this.saveLoading = false
      })
    },
    saveSuccessMsg () {
      this.saveMessage = '已保存'
      setTimeout(() => {
        this.saveMessage = ''
      }, 3000)
    },
    saveBefore (worksObj) {
      let { width, height } = this.widthAndHeight
      let item = this.dataList[0]
      Object.assign(worksObj, {
        widthHeight: `${width}x${height}`,
        projectId: this.projectId,
        json: { dataList: this.dataList }
      })
      let app = this.$store.state.app
      let preliminaryProject =
        worksObj.projectId === app.loginUser.preliminaryProject.id
      let isPublicTpl = app.publicTemplateId
      if (isPublicTpl || preliminaryProject) {
        //公共模板 或者是预置项目模板保存作品时，项目id使用当前store中的
        worksObj.projectId = app.projectId
      }
      return worksObj
    },
    saveAction () {
      this.saveUserAction(
        this.getActionPage().name.key,
        this.getActionPage().save.key,
        this.worksObj.type,
        null,
        this.worksObj.tplGroupName
      )
    },
    save (params, status, syncUpdateCover) {
      this.saveBefore(params)
      return workService
        .saveWorks(params, status, syncUpdateCover)
        .then(data => {
          return Promise.resolve(data)
        })
        .catch(resp => {
          if (resp.code === error_code_400003) {
            this.$message.error(resp.message)
          }
          return Promise.reject(resp)
        })
    },
    onItemClick (item) {
      if (item.disabled) {
        this.panelVisibleValue = 'basePanel'
        return
      }
      if (item.isEditableTable) {
        this.$store.commit('templateGroup/set_selected_item', item)
        this.tablePanelData = item
        this.panelVisibleValue = 'tablePanel'
        return
      }
      if (item.type === 'text') {
        this.panelVisibleValue = 'textPanel'
        return
      }
      if (item.type === 'img') {
        this.panelVisibleValue = 'materialPanel'
        return
      }
      this.panelVisibleValue = 'basePanel'
    },
    onTableClick (item) {
      this.userWordData = item
      this.tablePanelData = item
      this.panelVisibleValue = 'tablePanel'
      this.wordUserDialogVisible = true
    },
    onHeightChange ({ oldHeight, newHeight }) {
      if (newHeight - oldHeight > 0) {
        this.originHeight = oldHeight
        this.extendBg()
      }
    },
    async onItemExport (item) {
      // this.saveUserAction(this.getActionPage().name.key, this.getActionPage().export_png.key, this.worksObj.type, item.id);

      this.exportLoadingData.push(item.onlyId)
      let { id, projectId } = await this.syncWork()
      let fileName = `${item.name}.png`
      workService
        .exportPart(projectId, id, item.id, item.onlyId)
        .then(resp => {
          util.download(resp, fileName)
          return Promise.resolve(resp)
        })
        .catch(() => {
          this.$message.error('图片获取失败')
        })
        .finally(() => {
          this.exportLoadingData = this.exportLoadingData.filter(onlyId => {
            return item.onlyId !== onlyId
          })
        })
    },
    handleCheckAllChange (val) {
      if (val) {
        this.exportCheckList = this.dataList.map(item => {
          return item.id
        })
      } else {
        this.exportCheckList = []
      }
    },
    onExportHide () {
      this.exportCheckList = []
      this.checkAll = false
    },
    async exportPPT (projectId, workId) {
      return workService
        .exportPPT(projectId, workId)
        .then(response => {
          util.download(response)
        })
        .catch(error => {
          this.$message.error('导出失败')
        })
    },
    async exportMultiSlice (workId, projectId, imgSuffix) {
      return workService
        .multiSliceExport(workId, projectId, imgSuffix)
        .then(response => {
          util.download(response)
        })
        .catch(error => {
          this.$message.error('导出失败')
        })
    },
    setLocalFormExportType () {
      window.localStorage.setItem('exportFileType', this.exportFileType)
      window.localStorage.setItem('exportType', this.exportType)
    },
    onExport (exportFileType) {
      if (exportFileType === 'ppt') {
        this.exportPPTEvent()
      } else {
        this.exportNormalEvent(exportFileType)
      }
    },
    onMultiModeExport () {
      let exportFileType = this.exportFileType,
        exportType = this.exportType
      if (!exportFileType || !this.exportType) {
        this.$message.error('请选择文件类型和下载方式')
        this.exportLoading = false
        return
      }
      this.setLocalFormExportType()
      if (exportFileType === 'ppt') {
        this.exportPPTEvent()
      } else if (exportType === 'slice') {
        this.exportSliceEvent(exportFileType)
      } else {
        this.exportNormalEvent(exportFileType)
      }
    },
    async exportNormalEvent (exportFileType) {
      this.exportLoading = true
      let { id } = await this.syncWork().catch(() => {})
      let fileName = `${this.worksObj.name}.${exportFileType}`
      workService
        .exportWork({ id })
        .then(res => {
          util.download(res, fileName)
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '导出失败',
            showClose: true
          })
        })
      this.exportLoading = false
      let key = exportFileType === 'png' ? 'export_png' : 'export_jpg'
      this.saveUserAction(
        this.getActionPage().name.key,
        this.getActionPage()[key].key,
        this.worksObj.type,
        null,
        this.worksObj.tplGroupName
      )
    },
    async exportSliceEvent (exportFileType) {
      this.exportLoading = true
      let { id } = await this.syncWork().catch(() => {})
      this.exportMultiSlice(
        id,
        this.worksObj.projectId,
        exportFileType
      ).finally(() => {
        this.exportLoading = false
      })
      this.saveUserAction(
        this.getActionPage().name.key,
        this.getActionPage()['export_multiple'].key,
        this.worksObj.type,
        null,
        this.worksObj.tplGroupName
      )
    },
    async exportPPTEvent () {
      this.exportLoading = true
      let { id } = await this.syncWork(false).catch(() => {
        this.exportLoading = false
      })
      this.pptLoading = true
      this.percentage = 0
      this.setPercentage()
      this.exportPPT(this.worksObj.projectId, id).finally(() => {
        this.exportLoading = false
        this.percentage = 100
        this.time = null
        setTimeout(() => {
          this.pptLoading = false
        }, 0)
      })
      this.saveUserAction(
        this.getActionPage().name.key,
        this.getActionPage()['export_ppt'].key,
        this.worksObj.type,
        null,
        this.worksObj.tplGroupName
      )
    },
    setPercentage () {
      if (this.percentage < 20) {
        this.time = window.setTimeout(() => {
          this.percentage += 1
          if (this.percentage < 90) {
            this.setPercentage()
          } else {
            this.time = null
          }
        }, 50)
      } else {
        this.time = window.setTimeout(() => {
          this.percentage += 1
          if (this.percentage < 90) {
            this.setPercentage()
          } else {
            this.time = null
          }
        }, 1000)
      }
    },
    onTemplateClick (ev) {
      ev.stopPropagation()
      if (ev.target.className.indexOf('tpl-editor-area-overflow') > -1) {
        this.panelVisibleValue = 'basePanel'
      }
      this.onMoveClick(ev)
    },
    onKeydown (minusOrPlus, height) {
      let isPPT = template_type_ppt === this.currentItem.type
      if (isPPT) {
        // ppt模板不支持模板高宽修改
        return
      }
      let json = this.currentItem.json
      if (minus_plus.plus == minusOrPlus) {
        json.height = +json.height + height
      } else {
        json.height = +json.height - height
      }
    },
    onReplaceTableTheme (url, htmlStr) {
      this.addCache()
      this.replaceTableImg(this.selectedItem, url, htmlStr)
      this.selectedItem.key = util.getUUID()
    },
    replaceTableImg (item, url, htmlStr) {
      item.htmlViewImg = url
      item.htmlStr = htmlStr
    },
    onWordDialogConfirm ({ url, htmlStr, height }) {
      this.addCache()
      let selectedItem = this.selectedItem
      this.replaceTableImg(selectedItem, url, htmlStr)
      if (this.currentItem.type === this.ppt) {
        return
      }
      let value = +height - +selectedItem.height
      let minusOrPlus = value > 0 ? minus_plus.plus : minus_plus.minus
      if (value !== 0) {
        let json = this.currentItem.json
        TUtil.moveItem(json, selectedItem, minusOrPlus, Math.abs(value))
        this.$store.commit('templateGroup/set_selected_item', selectedItem)
      }
    },
    showHiddenDialog () {
      this.hiddenDialogVisible = true
      this.saveUserAction(
        this.getActionPage().name.key,
        this.getActionPage().toggleHide.key
      )
    },
    onUpdateTemplate (item) {
      this.$confirm(`确定更新模板“${item.name}”`, '', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          templateService.updateTemplate(item, true).then(() => {
            this.$message.success('更新成功')
          })
        })
        .catch(() => {})
    },
    onOpenMaterial () {
      if (this.panelVisibleValue !== 'materialPanel') {
        // 首次进来查询素材，其它时候点击不需要查询
        setTimeout(() => {
          this.$refs.materialPanelRef._search('')
        })
      }
      this.panelVisibleValue = 'materialPanel'
    },
    getWordTableList (dataList) {
      let ids = this.getIds(dataList)
      this.templateIds = ids
    },
    onCutImg () {
      this.saveUserAction(
        this.getActionPage().name.key,
        this.getActionPage().cutImg.key
      )
    },
    getActionPage () {
      return this.ActionType.templateGroup.editor
    },
    async generateImg () {
      let loadingInstance = Loading.service({
        fullscreen: true,
        text: '加载取色器工具'
      })
      let { id, url } = await this.syncWork().catch(() => {
        loadingInstance.close()
      })
      this.theColorUrl = url
      loadingInstance.close()
    },
    delTagVisible (templateId) {
      let delIds = this.worksObj.deletedLinkedTemplateIds
      let isDel = delIds && delIds.length > 0 && delIds.indexOf(templateId) > -1
      return isDel
    },
    onOpenAdminDialog () {
      this.wordData = this.selectedItem
      this.themeData = {}
      this.wordAdminDialogVisible = true
    },
    onOpenThemeDialog (item) {
      this.themeData = item
      this.wordData = this.selectedItem
      this.wordAdminDialogVisible = true
    },
    onCloseThemeDialog () {
      setTimeout(() => {
        this.themeData = {}
      }, 200)
    },
    onRemoveModule () {
      this.panelVisibleValue = 'basePanel'
    },
    goHome () {
      util.goHomeBefore(this, this.hasCacheData)
    }
  }
}
</script>
<style lang="scss">
@import './template-group-index';
</style>
